import { combineReducers } from 'redux';
import inputData from './inputData/reducer';

const rootReducer = combineReducers({
    inputData
})

export default rootReducer;